export default {
  MAARAKAM: "MAARAKAM",
  PAATHAKAM: "PAATHAKAM",
  KENDIRAM: "KENDIRAM",
  LAGNAM: "LAGNAM",
  TRIKONAM: "TRIKONAM",
};
